import React, { createContext, useState, useCallback, useEffect } from 'react';
import ToastContainer from '../components/common/ToastContainer';
import { SAVE_FAILED_EVENT } from '../utils/saveFailureNotice';

export const ToastContext = createContext();

let toastId = 0;

/* 긴 실패 안내(서버가 «무엇을 하라»까지 적어 준 것)는 5초에 다 못 읽는다 — 기본 길이일 때만 늘린다(2026-10-19) */
export const readableDuration = (message, type, duration) => (
  type === 'error' && duration === 5000 && String(message || '').length > 120 ? 12000 : duration
);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'success', duration = 5000) => {
    const id = toastId++;
    /* 같은 알림이 아직 떠 있으면 또 쌓지 않는다 — 칸을 고칠 때마다 저장이 실패해 같은 «실패» 알림이
       화면을 덮을 만큼 쌓였다(2026-10-19 Jun 영상, 10개 이상) */
    setToasts((prev) => (prev.some((t) => t.message === message && t.type === type)
      ? prev
      : [...prev, { id, message, type, duration: readableDuration(message, type, duration) }]));
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  const showSuccess = useCallback((message, duration) => {
    addToast(message, 'success', duration);
  }, [addToast]);

  const showError = useCallback((message, duration) => {
    addToast(message, 'error', duration);
  }, [addToast]);

  /* 화면 밖(api 모듈)에서 난 서버 저장 실패도 알림으로 띄운다(2026-10-02 저장 최종점검 S4, utils/saveFailureNotice). */
  useEffect(() => {
    const onFailed = (e) => { if (e?.detail?.message) addToast(e.detail.message, 'error', 8000); };
    window.addEventListener(SAVE_FAILED_EVENT, onFailed);
    return () => window.removeEventListener(SAVE_FAILED_EVENT, onFailed);
  }, [addToast]);

  return (
    <ToastContext.Provider value={{ addToast, showSuccess, showError, removeToast }}>
      {children}
      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </ToastContext.Provider>
  );
};
